import React, { Component } from 'react';
import ComTable from '../ComTable';

class SystemExp extends Component {
    state = {
        config: [],
        loading: false,
    }

    componentDidMount() {
        const config = [{
            zh: '系统类型',
            en: 'System Type',
            key: 'systemType',
        }, {
            zh: '系统名称',
            en: 'System Name',
            key: 'systemName',
            width: 420,
        }, {
            zh: '公司名称',
            en: 'Company Name',
            key: 'companyName',
            width: 320,
        }];
        this.setState({ config });
    }

    getDataSource = () => {
        const { data, isChinese } = this.props;
        const dataSource = data.map((item, index) => {
            const {
                systemTypeChinese,                      // 系统类型备注
                systemTypeEnglish,                      
                systemNameChinese,                      // 系统名称（系统类型选其他时）
                systemNameEnglish, 
                companyNameChinese,
                companyNameEnglish,
                systemExperienceTypeChineseName,        // 系统类型name
                systemExperienceTypeEnglishName,
                systemExperienceNameChineseName,        // 系统名称name
                systemExperienceNameEnglishName,
                systemNameCommentsChinese,              // 系统名称备注
                systemNameCommentsEnglish,
            } = item;
            const systemType = isChinese ? systemExperienceTypeChineseName : systemExperienceTypeEnglishName;
            const systemTypeComments = isChinese ? systemTypeChinese : systemTypeEnglish;
            const systemName = isChinese ? (systemNameChinese || systemExperienceNameChineseName) : (systemNameEnglish || systemExperienceNameEnglishName);
            const systemNameComments = isChinese ? systemNameCommentsChinese : systemNameCommentsEnglish;
            return {
                index: index + 1,
                ...item,
                systemType: `${systemType}${systemTypeComments ? `(${systemTypeComments})` : ''}`,
                systemName: `${systemName}${systemNameComments ? `(${systemNameComments})` : ''}`,
                companyName: isChinese ? companyNameChinese : companyNameEnglish,
            }
        });
        return dataSource;
    }

    render() {
        const { isChinese } = this.props;
        const { config, loading } = this.state;
        const result = config.map(item => {
            if (isChinese) {
                item.title = item.zh;
            } else {
                item.title = item.en;
            }
            return item;
        });
        return (
            <ComTable
                config={result}
                loading={loading}
                pagination={false}
                getDataSource={this.getDataSource}
            />
        );
    }
}

export default SystemExp;


// WEBPACK FOOTER //
// ./src/components/common/generateCurriculumVitae/SystemExp.js